
import Api from './api';
const api = new Api();

export async function fetchRemovedDefaultTemplateControls(riskId) {
  const { data } = await api.get(`/__api/v1/risks/${riskId}/default_template_control_notes`);
  return data;
}


// WEBPACK FOOTER //
// ./src/services/risksService.js